import "./TermsAndConditions.module.css";
import Header from "@/reusable_sections/Header";
import Terms from "./sections/Terms";
import Footer from "@/reusable_sections/Footer";
export default function TermsAndConditionsPage() {
  return <div>
      <Header />
      <Terms />
      <Footer />
    </div>;
}